import { render, staticRenderFns } from "./CommonHead.vue?vue&type=template&id=6481cd52&scoped=true"
import script from "./CommonHead.vue?vue&type=script&lang=js"
export * from "./CommonHead.vue?vue&type=script&lang=js"
import style0 from "./CommonHead.vue?vue&type=style&index=0&id=6481cd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481cd52",
  null
  
)

export default component.exports